/* eslint-disable */

import React from 'react';
import { object, func } from 'prop-types';

import './Recommendation.scss';

function Recommendation({ callExternalAPI, clickedLink, recommendation }) {
  const {
    title,
    description,
    action_link: actionLink,
    action_text: actionText,
    completed_at: completedAt,
    buttons,
    slack_message_json_blocks,
  } = recommendation;

  return (
    <>
      <div
        className={`d-flex flex-grow-1 justify-content-between recommendation  ${
          completedAt ? 'text-super-muted' : ''
        }`}
      >
        <div className="recommendation-content">
          <h5 className="recommendation-title">{title}</h5>
          <h5 className="recommendation-description">{description}</h5>

          {slack_message_json_blocks && (
            <div>
              <a
                target="_blank"
                href={
                  'https://api.slack.com/tools/block-kit-builder?mode=message&blocks=' +
                  encodeURIComponent(JSON.stringify(slack_message_json_blocks))
                }
                className="btn btn-info btn-sm recommendation-button pr-4 pl-4 mr-2"
                rel="noopener noreferrer"
              >
                Slack preview
              </a>
            </div>
          )}
        </div>

        <div className="d-flex align-items-center recommendation-buttons">
          {!completedAt && actionLink && actionText && (
            <a
              target="_blank"
              onClick={() => clickedLink('action_link', actionLink)}
              href={actionLink}
              className="btn btn-secondary recommendation-button mr-2"
              rel="noopener noreferrer"
            >
              {actionText}
            </a>
          )}

          {buttons &&
            buttons.map(button => {
              if (button.type === 'external_api_call') {
                return (
                  <a
                    key={button.key}
                    href="javascript:void(0);"
                    className="btn btn-secondary recommendation-button pr-4 pl-4 mr-2"
                    onClick={() => callExternalAPI({ recommendation_id: recommendation.id, button_key: button.key })}
                  >
                    {button.text}
                  </a>
                );
              }
              if (button.type === 'link') {
                return (
                  <a
                    target="_blank"
                    onClick={() => clickedLink(button.key, button.link)}
                    key={button.key}
                    href={button.link}
                    className="btn btn-secondary recommendation-button pr-4 pl-4 mr-2"
                    rel="noopener noreferrer"
                  >
                    {button.text}
                  </a>
                );
              }
            })}
        </div>
      </div>
      <hr className="recommendation-line" />
    </>
  );
}

Recommendation.propTypes = {
  recommendation: object.isRequired,
  callExternalAPI: func.isRequired,
  clickedLink: func.isRequired,
};

export default Recommendation;
